import React from 'react'

import AnalyticsSectionContent, { IAnalyticsSectionContentProps } from './AnalyticsSectionContent'

const TopQueries: React.SFC<IAnalyticsSectionContentProps> = (props) => (
  <AnalyticsSectionContent title="Top Queries" {...props} />
)

export default TopQueries
